import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { BaseComponent } from '../BaseComponent';
import { HBox } from '../Box';
import { makeSelectLocale } from '../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../modules/Companies/translate-countries';

const Container = styled.div`
  > .box {
    align-items: center;
    border-bottom: 1px solid #ddd;
  }
  .name {
    margin-right: 12px;
    width: 200px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class AddressComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  get locale() {
    return this.props.locale;
  }

  get name() {
    return this.props.address.name;
  }

  get type() {
    return this.props.address.type.name;
  }

  get postcode() {
    return this.props.address.postcode;
  }

  get addressLine1() {
    return this.props.address.addressLine1;
  }

  get addressLine2() {
    return this.props.address.addressLine2;
  }

  get city() {
    return this.props.address.city;
  }

  get country() {
    return translateCountry(this.props.address.country.name, this.locale);
  }

  render() {
    return (
      <Container>
        <HBox>
          <div className="name">
            <p>
              <b>Name</b> {this.name}
            </p>
            <p>
              <b>Type</b> {this.type}
            </p>
            <p>
              <b>Postcode</b> {this.postcode}
            </p>
          </div>
          <div className="name">
            <p>
              <b>Line 1</b> {this.addressLine1}
            </p>
            <p>
              <b>Line 2</b> {this.addressLine2}
            </p>
          </div>
          <div className="name">
            <p>
              <b>City</b> {this.city}
            </p>
            <p>
              <b>Country</b> {this.country}
            </p>
          </div>
        </HBox>
      </Container>
    );
  }
}

AddressComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Address = compose(withConnect, withRouter)(AddressComp);
